<template>
  <div class="device-expired">
    <div class="query-filter" v-if="isFilter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item" v-if="isCoJv && showSubsidiary">
              <div class="label">{{ $t('device_expired_zu_lin_fang') }}</div>
              <div class="value">
                <custom-select
                  url="OrganSelect"
                  :model="formSearch"
                  :params="{ childOrgType: 'CS' }"
                  v-model="formSearch.customerId"
                  :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                  :placeholder="$t('com_please_select')"
                  @change="onPageChange({ page: 1 })"
                  filterable
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_expired_xiang_mu') }}</div>
              <div class="value">
                <custom-select
                  filterable
                  :listener="formSearch.customerId"
                  url="MyDeviceLocationTagSelect"
                  :model="formSearch"
                  v-model="formSearch.locationId"
                  :params="{ customerId: isCoJv ? (showSubsidiary ? formSearch.customerId : '') : userInfo.rootOrgId }"
                  :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName' } }"
                  :placeholder="$t('com_please_select')"
                  @change="onPageChange({ page: 1 })"
                  theme="yellow"
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_expired_suo_shu_bu_men') }}</div>
              <div class="value">
                <custom-select
                  url="DepartmentTree"
                  v-model="formSearch.departmentId"
                  :model="formSearch"
                  :props="{ label: 'bizName', value: 'bizId', checkStrictly: true, map: { bizName: 'departmentName' } }"
                  :params="{ isCountDevice: 1 }"
                  :placeholder="$t('com_please_select')"
                  width="100%"
                  ref="tag"
                  type="tree"
                  filterable
                  :dataFilter="departmentTreeFilter"
                  @treeValChange="onPageChange({ page: 1 })"
                  @treeValChangeLabel="onDepartmentLabel"
                  @getList="onDepartmentList"
                  :clearable="false"
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_expired_cpxh') }}</div>
              <div class="value">
                <custom-select
                  url="productCodeSelectList"
                  multiple
                  v-model="formSearch.productCode"
                  :props="{ label: 'productCode', value: 'productCode' }"
                  @change="onProductChange"
                  :placeholder="$t('com_please_select')"
                  width="100%"
                  theme="yellow"
                ></custom-select>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('device_expired_shai_xuan_xiang') }}：</div>
        <div class="values">
          <el-tag
            key="1"
            v-if="formSearch.customerId"
            closable
            @close="
              formSearch.customerId = '';
              formSearch.orgName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.orgName }}
          </el-tag>
          <el-tag
            key="3"
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag
            v-if="formSearch.departmentId"
            closable
            @close="
              formSearch.departmentId = '';
              formSearch.departmentName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.departmentName }}
          </el-tag>
          <!-- <el-tag
            closable
            v-for="productTag in productTagList"
            :key="productTag.value"
            @close="onCloseTag(productTag.value, 'productTagList', 'productCode')"
          >{{ productTag.label }}</el-tag> -->
          <el-tag closable v-for="productTag in productTagList" :key="productTag.value" @close="onCloseTag(productTag.value, 'productTagList', 'productCode')">{{ productTag.label }}</el-tag>

          <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
        </div>
      </div>
    </div>
    <div class="table-content">
      <div class="header">
        <div class="tab-box">
          <el-form :inline="true" @submit.native.prevent class="form-screen" style="display: flex">
            <el-form-item style="flex: 1; text-align: center; margin-bottom: 0">
              <div class="status-type1">
                <ul>
                  <li class="item" :class="formSearch.timeType.includes('one') ? 'active' : ''" @click="onStateChange('one')">
                    <i class="point one"></i>
                    <p>
                      {{ $t('device_expired_tian') }}
                      <span>({{ deviceCount.one }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.timeType.includes('two') ? 'active' : ''" @click="onStateChange('two')">
                    <i class="point two"></i>
                    <p>
                      {{ $t('device_expired_tian_1') }}
                      <span>({{ deviceCount.two }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.timeType.includes('three') ? 'active' : ''" @click="onStateChange('three')">
                    <i class="point three"></i>
                    <p>
                      {{ $t('device_expired_tian_2') }}
                      <span>({{ deviceCount.three }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.timeType.includes('four') ? 'active' : ''" @click="onStateChange('four')">
                    <i class="point four"></i>
                    <p>
                      {{ $t('device_expired_tian_3') }}
                      <span>({{ deviceCount.four }})</span>
                    </p>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table-bd">
        <custom-table
          tableCode="portal_device_expired"
          height="100%"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          :slots="['expiringDays', 'action']"
          :filterArr="filterArr"
          @filter="filterChange"
          @sort="sortChange"
        >
          <template v-slot:expiringDays="scope">
            <span v-if="scope.row" class="dit-item" :class="scope.row.timeType">{{ scope.row.expiringDays }}</span>
          </template>
          <template v-slot:action="scope">
            <span v-if="scope.row.projectContactPhone">
              <el-button type="text" size="mini" @click="continueRent(scope.row)">{{ $t('device_expired_xu_zu') }}</el-button>
            </span>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

// device_expired_zu_lin_fang: 租赁方// device_expired_xiang_mu: 项目// device_expired_suo_shu_bu_men: 所属部门// device_expired_cpxh: 产品型号// device_expired_shai_xuan_xiang: 筛选项// device_expired_tian: 0-30天// device_expired_tian_1: 31-60天// device_expired_tian_2: 61-90天// device_expired_tian_3:  >90天// device_expired_xu_zu: 续租// device_expired_xu_zu_dian_hua: 续租电话：// device_expired_xu_zu_2: 续租

export default {
  name: 'device_expired',
  props: {
    isFilter: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    filterArr() {
      return this.isCoJv ? [] : ['orgName'];
    },
  },
  data() {
    return {
      productTagList: [], // 产品多选标签
      formSearch: {
        search: this.value,
        pageNum: 1,
        pageSize: 50,
        customerId: '',
        orgName: '',
        locationId: '',
        locationName: '',
        productCode: '',
        timeType: [],
        showSubsidiary: '',
        departmentId: '',
        departmentName: '',
      },
      deviceCount: {},
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_device_expired');
    if (this.getJump('timeType')) {
      this.formSearch.timeType = [this.getJump('timeType')];
    }
    this.getTableList();
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 特殊处理一下 因为是在父级
    setColumn: function (table) {
      const column = this.$parent.$refs[table.columnRef || 'column'];
      if (column) {
        column.tableCode = table.tableCode;
        column.tableColumn = table.tableColumn;
        column.formatTable();
      }
    },
    // 产品型号多选
    onProductChange(data) {
      if (!data || !data.length) {
        this.productTagList = [];
      } else {
        this.productTagList = data.map(item => ({
          label: item.productCode,
          value: item.productCode,
          ...item,
        }));
      }
      this.onPageChange({ page: 1 });
    },
    // 清空
    onClear() {
      this.productTagList = [];
      this.formSearch.customerId = '';
      this.formSearch.orgName = '';
      this.formSearch.locationId = null;
      this.formSearch.locationName = '';
      this.formSearch.productCode = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },
    // 筛选
    onStateChange(type) {
      if (this.formSearch.timeType.includes(type)) {
        this.formSearch.timeType = this.formSearch.timeType.filter(item => item !== type);
      } else {
        this.formSearch.timeType = [...this.formSearch.timeType, type];
      }
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 获取设备数量
    getDeviceCount() {
      this.$getJSON(apis.ProtalDeviceExpiringCount, {
        ...this.formSearch,
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
      }).then((res) => {
        const data = res.data || {};
        this.deviceCount = data;
      });
    },
    // 获取数据
    getTableList() {
      this.formSearch.search = this.value;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.getDeviceCount();
      this.$getJSON(apis.ProtalDeviceExpiringPage, {
        ...this.formSearch,
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
      }).then(async (res) => {
        const deviceList = res.data.list || [];
        this.tableList = deviceList;
        this.totalRows = res.data.total;
      });
    },
    onExport() {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('PortalDeviceExpiringExport', { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' });
    },
    // 续租
    continueRent(item) {
      this.$alert(`${this.$t('device_expired_xu_zu_dian_hua')} ${item.projectContactPhone}`, this.$t('device_expired_xu_zu_2'), {
        confirmButtonText: this.$t('com_confirm'),
        confirmButtonClass: 'comfirm-button',
        callback: () => {},
      });
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.comfirm-button {
  color: #ffffff !important;
  background-color: #ffad00 !important;
  border-color: #ffad00 !important;
}
.device-expired {
  .status-type1 {
    align-self: center;
    ul {
      display: flex;
      li {
        height: 32px;
        line-height: 32px;
        border-radius: 47px;
        border: 1px solid #efefef;
        margin-right: 8px;
        padding: 0 12px;
        font-size: 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.active {
          background: $--color-primary;
          p {
            color: #fff;
            font-family: PingFangSC-Semibold, PingFang SC;
            span {
              color: #fff;
              font-family: PingFangSC-Regular, PingFang SC;
            }
          }
          .point {
            background-color: #fff !important;
          }
        }
        p {
          margin-left: 8px;
          font-size: 12px;
          color: #333333;
          line-height: 32px;
          font-size: 12px;
          font-weight: bold;
          color: $--color-text-regular;
          line-height: 18px;
          span {
            font-size: 12px;
            margin-left: 4px;
            color: $--color-text-secondary;
            line-height: 18px;
          }
        }
        .point {
          width: 10px;
          height: 10px;
          display: inline-block;
          background: $--color-primary;
          border-radius: 50%;
          &.one {
            background: #eb5a5a;
          }
          &.two {
            background: #ffad00;
          }
          &.three {
            background: #93da49;
          }
          &.four {
            background: #00a0d9;
          }
        }
      }
    }
  }

  .dit-item {
    display: block;
    padding: 0 10px;
    width: 80px;
    color: #ffffff;
    border-radius: 23px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #b3b3b3;
    &.one {
      background: #eb5a5a;
    }
    &.two {
      background: #ffad00;
    }
    &.three {
      background: #93da49;
    }
    &.four {
      background: #00a0d9;
    }
  }
}
</style>
